/**
 * Фаза суток для «неба дня».
 *
 * Отдельным модулем от компонентов: чистая функция, которую удобно проверять
 * и которая не должна ломать hot-reload декора.
 */

export type SkyPhase = 'dawn' | 'day' | 'dusk' | 'night'

/** Фаза суток по местному часу. Границы бытовые, а не астрономические. */
export function skyForHour(hour: number): SkyPhase {
  if (hour < 5) return 'night'
  if (hour < 10) return 'dawn'
  if (hour < 17) return 'day'
  if (hour < 22) return 'dusk'
  return 'night'
}
